var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-auto pr-3" },
    [
      _c(
        "router-link",
        {
          staticClass: "title text-secondary clickable",
          attrs: { id: "back-button", to: _vm.route },
        },
        [
          _c("span", [
            _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_back")]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }